import { PRODUCT_MAP } from "./products";

const RULES = [
  { a: "jet", b: "gasoline", level: "high", msg: "Jet-A next to gasoline or avgas: risk of contaminating aviation fuel through a shared bulkhead. Put a diesel or dry pocket between them." },
  { a: "jet", b: "avgas", level: "high", msg: "Jet-A next to avgas: aviation fuel mix-up is critical. Put a dry or diesel pocket between them." },
  { a: "avgas", b: "gasoline", level: "medium", msg: "Avgas next to motor gasoline: ethanol or car gas in avgas is not allowed. Check the bulkhead seals and valves." },
  { a: "jet", b: "dyed", level: "medium", msg: "Jet-A next to dyed fuel: dye can contaminate the aviation fuel. Separate them if you can." },
  { a: "dyed", b: "clear", level: "medium", msg: "Dyed fuel next to clear on-road diesel: dye can get into the on-road fuel. Check the bulkhead seals and valves." },
];

const tag = (id) => {
  const p = PRODUCT_MAP[id];
  if (id === "avgas") return "avgas";
  if (p.group !== "diesel") return p.group;
  return p.dyed ? "dyed" : "clear";
};

export function pairRule(x, y) {
  if (!x || !y || x === y) return null;
  const tx = tag(x);
  const ty = tag(y);
  return RULES.find((r) => (r.a === tx && r.b === ty) || (r.a === ty && r.b === tx)) || null;
}

export function checkSafety(loads, compartments) {
  const out = [];
  for (let i = 0; i < loads.length - 1; i++) {
    const rule = pairRule(loads[i].product, loads[i + 1].product);
    if (rule) out.push({ left: i, right: i + 1, level: rule.level, msg: rule.msg,
      title: `${compartments[i].name} ↔ ${compartments[i + 1].name}` });
  }
  return out;
}
